
import { api } from '../common.api';

export const cronApi = api.injectEndpoints({
  endpoints: (build) => ({
    triggerCron: build.mutation<void, void>({
      query: () => ({
        url: '/cron/trigger',
        method: 'POST',
      }),
      invalidatesTags: ['Post', 'Campaign'],
    }),
  }),
});

export const { useTriggerCronMutation } = cronApi;
